import React from 'react'
import s from './KpiCards.module.scss'

type Tone = 'brand' | 'lime' | 'green' | 'coral'

interface IKpiCard {
    label: string
    value: number
    total?: number
    tone?: Tone
    icon?: string
}

const ringColors: Record<Tone, { ring: string; track: string }> = {
    brand: { ring: '#FFFFFF', track: 'rgba(255,255,255,0.28)' },
    lime: { ring: '#4C1A63', track: 'rgba(76,26,99,0.22)' },
    green: { ring: '#2F9E5B', track: '#E4DEF3' },
    coral: { ring: '#F0564A', track: '#E4DEF3' },
}

const KpiCard: React.FC<IKpiCard> = ({ label, value, total, tone = 'brand', icon }) => {
    const pct = total && total > 0 ? Math.min(100, Math.round((value / total) * 100)) : value > 0 ? 100 : 0
    const R = 26
    const C = 2 * Math.PI * R
    const dash = (pct / 100) * C
    const c = ringColors[tone]

    return (
        <div className={`${s.card} ${s[tone]}`}>
            <div className={s.inner}>
                <div className={s.ringWrap}>
                    <svg width="64" height="64" viewBox="0 0 72 72" className={s.ring}>
                        <circle cx="36" cy="36" r={R} fill="none" stroke={c.track} strokeWidth="6" />
                        <circle
                            cx="36"
                            cy="36"
                            r={R}
                            fill="none"
                            stroke={c.ring}
                            strokeWidth="6"
                            strokeLinecap="round"
                            strokeDasharray={`${dash} ${C}`}
                        />
                    </svg>
                    {icon ? <img className={s.icon} src={icon} alt="" width={20} height={20} /> : null}
                </div>
                <div className={s.meta}>
                    <div className={s.value}>{value}</div>
                    <div className={s.label}>{label}</div>
                </div>
            </div>
        </div>
    )
}

export interface IKpiDevice {
    status?: boolean
    errorId?: number
    name?: string
}

const KpiCards: React.FC<{ devices: IKpiDevice[] }> = ({ devices }) => {
    const total = devices.length
    const working = devices.filter((d) => d.status !== false && (d.errorId ?? 0) === 0).length
    const errors = total - working
    const partners = new Set(devices.map((d) => d.name).filter(Boolean)).size

    return (
        <div className={s.row}>
            <KpiCard label="Всего аппаратов" value={total} tone="brand" icon="/images/print.svg" />
            <KpiCard label="Работают" value={working} total={total} tone="lime" icon="/images/check.svg" />
            <KpiCard label="Ошибки" value={errors} total={total} tone="coral" icon="/images/error.svg" />
            <KpiCard label="Партнёров" value={partners} tone="green" icon="/images/users.svg" />
        </div>
    )
}

export default KpiCards
